import { createI18n } from 'vue-i18n'
import en from '@/core/locales/en.json'
import es from '@/core/locales/es.json'

type locale = 'en'|'es'

interface language {
  name: string
  locale: locale
  icon: string
}

const languages: language[] = [
  {
    name: 'Español',
    locale: 'es',
    icon: 'flag-icon-mx'
  },
  {
    name: 'English',
    locale: 'en',
    icon: 'flag-icon-us'
  }
]

const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages: { en, es }
})

// Función para cargar las traducciones dinámicamente
const loadLocaleMessages = async (locale: locale) => {
  try {
    i18n.global.locale.value = locale
  } catch (error) {
    console.error(`Error cargando las traducciones para el idioma ${locale}:`, error)
  }
}

export { i18n, loadLocaleMessages, languages, locale, language }
